<div class="event-description" fxLayout="row wrap" fxLayoutGap="10px" [fxLayoutAlign]=" !isHideSaleDate && showDateRange ? 'space-around center' : 'start center' ">
    <div fxLayout="row" fxLayoutGap="10px" *ngIf="!isHideSaleDate()">
    <ng-container *ngIf="showDateRange; else singleDateTemplate">
      <div class="perf-date" *ngIf="!isFlexibleEvent"
           fxLayout="row"
           fxLayoutAlign="start center"
           fxLayoutGap="8px">
        <mat-icon fontIcon="event" class="small-icon"></mat-icon>
        <span>Çeşitli Tarihler</span>
      </div>

      <div class="perf-date" *ngIf="isFlexibleEvent"
           fxLayout="row"
           fxLayoutAlign="start center"
           fxLayoutGap="8px">
        <mat-icon fontIcon="event" class="small-icon"></mat-icon>
        <span>{{ startDate | localizedDate : 'dd MMM yyyy EEE' }}</span>
        <span>-</span>
        <span>{{ endDate | localizedDate: 'dd MMM yyyy EEE' }}</span>
      </div>
    </ng-container>

    <ng-template #singleDateTemplate>
      <!--    -->
      <div class="perf-date"
           fxLayout="row"
           fxLayoutAlign="start center"
           fxLayoutGap="8px">
        <mat-icon fontIcon="event" class="small-icon"></mat-icon>
        <span class="date">{{ startDate | localizedDate: format }}</span>
        <span>&bull;</span>
        <span class="time">{{ startDate | localizedDate: timeFormat }}</span>
      </div>
    </ng-template>
  </div>

    <!-- Online Event-->

    <div class="liveEvent" *ngIf="liveEvent" fxLayout="row" fxFlex="50" fxLayoutAlign="space-around center">
      <mat-icon class="item-icon">videocam</mat-icon>
      <span>{{'performance.labels.liveEvent'| translate}}</span>

    </div>

    <div *ngIf="!liveEvent && !isHideVenue()" class="event-location"
         fxLayout="row"
         fxLayoutAlign="start center"
         fxLayoutGap="5px"
         [fxFlex]="showDateRange ? '50%' : null"
    >

        <!--        -->
        <ng-container *ngIf="venueUrl; else eventVenueTemplate">
            <a class="venue-link"
               fxLayout="row"
               fxLayoutGap="5px"
               fxLayoutAlign="start center"
               [href]="venueUrl"
               [class.activated]="venueUrl">
                <ng-template [ngTemplateOutlet]="eventVenueTemplate"></ng-template>
            </a>
        </ng-container>

        <ng-template  #eventVenueTemplate>
            <mat-icon class="material-icons-outlined animate small-icon"
                      fontIcon="place" >place
            </mat-icon>
            <span>{{ (venueName | shorten: 50) + ", " + venueCity }}</span>
        </ng-template>
    </div>




</div>
